import { render, staticRenderFns } from "./MarkSelect.vue?vue&type=template&id=ede96bee"
import script from "./MarkSelect.vue?vue&type=script&lang=js"
export * from "./MarkSelect.vue?vue&type=script&lang=js"
import style0 from "./MarkSelect.vue?vue&type=style&index=0&id=ede96bee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports